<div class="d-flex flex-row justify-content-between mb-2">
  <button class="btn btn-info mr-3" [style.min-width.px]="102" (click)="inviteUser()">+ Invite user</button>

  <tablesready-search-bar
    placeholder="Search user, email"
    btnColorClass="btn-light"
    [whiteIconColorEnabled]="false"
    (search)="searchUser($event)"
  ></tablesready-search-bar>
</div>

<div class="scroll-table" *ngIf="users.length > 0">
  <table class="table tr-table tr-striped">
    <thead>
    <tr>
      <th *ngIf="filters$ | async as filters">
        <tablesready-sortable-column
          [sortBy]="filters.sortBy"
          column="name"
          title="user"
          [orderAscending]="filters.sortReverse"
          (orderBy)="orderBy($event)"
        ></tablesready-sortable-column>
      </th>
      <th>Email</th>
      <th>
        <div class="filter-wide">
          <frontend-dropdown
            placeholder="Locations"
            bindLabel="name"
            bindValue="_id"
            customClass="old-filter-style"
            maxListHeight="9.3rem"
            [(ngModel)]="selectedLocationId"
            (ngModelChange)="filterByLocation()"
            [items]="locations"
            [clearable]="true"
          ></frontend-dropdown>
        </div>
      </th>
      <th>Actions</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let user of users | slice: start : end">
      <td>
        <span class="d-flex flex-row align-items-center">
          <span class="font-weight-bold mr-2" [innerText]="user.name"></span>
          <info-badge *ngIf="isAdmin(user)" label="ADMIN"></info-badge>
        </span>
      </td>
      <td [innerText]="user.email"></td>
      <td>
        <span *ngIf="isAdmin(user)">All locations</span>

        <div class="d-flex flex-row align-items-center" *ngIf="!isAdmin(user)">
          <span class="pb-0 pt-0 mr-2" [innerText]="user.locationUsers.length + ' location(-s)'"></span>
          <info-badge
            class="cursor-help"
            [tooltip]="userLocationsTooltips[user.id]"
            label="?"
          ></info-badge>
        </div>
      </td>
      <td>
          <span class="d-flex flex-row align-items-start">
            <button
              class="btn btn-icon btn-info mr-2"
              (click)="editUserAccess(user)"
              [disabled]="isEditingUser || buttonDisabled(user)"
            >
              <tr-icon [icon]="icon.edit" [color]="color.white"></tr-icon>
            </button>
            <button
              class="btn btn-danger delete-button"
              [disabled]="buttonDisabled(user)"
              (click)="removeUser(user)"
            >Delete user</button>
          </span>
      </td>
    </tr>
    </tbody>
  </table>
</div>

<div class="d-flex flex-row justify-content-end" *ngIf="users.length > 0">
  <div class="paginator">
    <ngb-pagination
      [(page)]="page"
      [pageSize]="pageSize"
      [maxSize]="maxSize"
      [ellipses]="true"
      [collectionSize]="users.length"
    ></ngb-pagination>
  </div>
</div>
